import React from "react";
import { moreSheet, contactSheet, rowLabelCheckboxSheet, SpecialConditionBox, getMemberSheet, getMemberFilterCellPhoneSheet } from "@icoach/components/";
import { formatCurrencyFn } from "@util/utils";
import { Typography } from "@curves/ui-base";

// 欠費名單
export const getFilterDebtLabel = (isRevealed, isShowContactGroup) => {
	return [
		{ ...rowLabelCheckboxSheet },
		{ ...getMemberSheet({ isRevealed }), isFixed: true, isFixedLeft: true },
		{ ...getMemberFilterCellPhoneSheet({ isRevealed, isShowContactGroup }) },
		{
			cellKey: "specialCondition",
			headerLabel: "聯繫注意與偏好",
			width: 18,
			formatCell: (specialCondition, { memberID }, { setSourceDataById }) => {
				return <SpecialConditionBox sourceData={{ memberID, value: specialCondition }} setSourceDataById={setSourceDataById} />;
			},
		},
		{
			cellKey: "membershipStatusText",
			headerLabel: "會籍狀態",
			align: "center",
		},
		{
			cellKey: "overdraftTotalPrice",
			headerLabel: "累積欠款",
			align: "right",
			formatCell: (value, { memberID }, { onOrderDialogClick }) => {
				return (
					<Typography className="cursor-pointer" onClick={() => onOrderDialogClick(memberID)}>
						{formatCurrencyFn(value)}
					</Typography>
				);
			},
		},
		{ ...contactSheet },
		{ ...moreSheet },
	];
};

export const filterDebtSortOption = [
	{
		text: "會員狀態遞增",
		value: 1,
		disabled: false,
	},
	{
		text: "會員狀態遞減",
		value: 2,
		disabled: false,
	},
	{
		text: "累積欠款遞增",
		value: 3,
		disabled: false,
	},
	{
		text: "累積欠款遞減",
		value: 4,
		disabled: false,
	},
];
